import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Lenspire_Icon_Check",
  "use": "Lenspire_Icon_Check-usage",
  "viewBox": "0 0 24 18",
  "content": "<symbol viewBox=\"0 0 24 18\" id=\"Lenspire_Icon_Check\">\n<g>\n\t<path d=\"M6.953,18l-6.69-6.575c-0.351-0.345-0.351-0.903,0-1.247c0.351-0.346,0.918-0.346,1.27,0l5.421,5.327L22.467,0.258\n\t\tc0.352-0.344,0.918-0.344,1.27,0c0.352,0.346,0.352,0.903,0,1.248L6.953,18z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./frontend/assets/icons/Lenspire_Icon_Check.svg
// module id = 563
// module chunks = 0